<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div :class="noticeTipShow?'content-tip':'content-no-tip'">
    <!--消息通知-->
    <div class="notice-tip-box" v-show="noticeTipShow">
      <van-notice-bar color="#ffffff" background="#F93B3B" left-icon="warning-o">
        退回原因：{{ noticeTipMsg }}
      </van-notice-bar>
    </div>
    <!--消息通知end-->

    <van-form @submit="submitJsy">
      <van-cell-group inset>
        <div class="upload-box">
          <van-field v-model="dzydbh" name="dzydbh" input-align="right" required :value="dzydbh" :rules="[{ validator:validatorDzydbh, message: '请填写电子运单编号' }]" placeholder="请填写电子运单编号">
            <template #label>
              <span class="input-left-label-hq">电子运单编号</span>
            </template>
          </van-field>

          <van-field v-model="dzydpz" name="dzydpz" input-align="right" required :value="dzydpz" :rules="[{ validator:validatorDzydpz, message: '请填写电子运单品种' }]" placeholder="请填写电子运单品种">
            <template #label>
              <span class="input-left-label-hq">电子运单品种</span>
            </template>
          </van-field>

          <van-field v-model="dzydsl" name="dzydsl" input-align="right" required :value="dzydsl" type="number" @keyup="clearNoNum" placeholder="请填写电子运单数量" :rules="[{ validator:validatorDzydsl, message: '请填写电子运单数量' }]" >
            <template #label>
              <span class="input-left-label-hq">电子运单数量</span>
            </template>
            <template #extra>
              <div class="unit">吨</div>
            </template>
          </van-field>

          <van-field v-model="dzydtyr" name="dzydtyr" input-align="right" :value="dzydtyr" :rules="[{ validator:validatorDzydtyr, message: '请填写电子运单托运人' }]" placeholder="请填写电子运单托运人">
            <template #label>
              <span class="input-left-label-hq red-required">电子运单托运人</span>
            </template>
          </van-field>

          <h2 class="upload-titile input-title-hq red-required title-extend">电子运单（请将电子运单的二维码和内容一起上传，可同时上传多张图片）</h2>
          <div class="upload-dzyd-box">
            <van-uploader v-model="indzydimage" :max-size="10240 * 1024" @oversize="onOversize" :before-read="beforeRead" :after-read="afterReadFile" :before-delete="deleteUploadImg"></van-uploader>
          </div>

          <h2 class="upload-titile input-title-hq red-required">上传车头照片</h2>
          <div class="upload-dzyd-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_zb_zm_image" :before-read="beforeRead" :after-read="uploadXszZbZm" :before-delete="deleteXszZbZm"></van-uploader>
          </div>
        </div>
      </van-cell-group>
      <div style="margin: 1rem;">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn">
          保存
        </van-button>
      </div>
    </van-form>
  </div>
</div>
</template>

<script>
import api from '@/fetch/api';
import Nav from "../Public/navTpl.vue"
import {
  Dialog,
  Toast
} from 'vant'
import Compressor from 'compressorjs';
//import orderDetailVue from '../Order/orderDetail.vue';
export default {
  components: {
    Nav,
  },
  data() {
    return {
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      fileList: [],
      id: '',
      uploadLoading: false,
      uploadDisabled: false,
      dzydbh: "",
      dzydpz: "",
      dzydsl: 0,
      dzydtyr: "",
      loadingBtn: false,

      indzydurl: "",
      indzydimage: [],
      indzydurlArr: [],
      indzydimageArr: [],
      noticeTipShow:false,
      noticeTipMsg:"",
      orderDetail:[],

      xsz_zb_zm_image: [],
      xsz_zb_zm_url: "",
    };
  },
  created() {
    var id = this.$route.params.id;
    this.$data.id = id;
    this.getOrderDetail(id);
  },
  methods: {
    deleteXszZbZm() {
      this.$data.xsz_zb_zm_url = "";
      this.$data.xsz_zb_zm_image = [];
    },

    getNoticeTipShow(detail,id)
    {
      var that = this;
      api.getNoticeTipShow(id).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          if(resData.data && detail.sfscdzyd == "1"){
            that.noticeTipShow = true;
            that.noticeTipMsg = resData.data;
          }
        } else {
          Toast.fail(resData.message);
        }
      }).catch(function() {
        //Toast.fail('error');
      });
    },
    getOrderDetail(id) {
      var that = this;
      api.getOrderDetail(id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var detail = res.data;
          that.orderDetail = detail;
          that.getNoticeTipShow(detail,id+','+'DZYD')
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });
    },
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },

    clearNoNum(e) {

      var o = e.target
      //如果用户第一位输入的是小数点，则重置输入框内容
      if (o.value != '' && o.value.substr(0, 1) == '.') {
        undefined
        o.value = "";
      }
      o.value = o.value.replace(/^0*(0\.|[1-9])/, '$1'); //粘贴不生效
      o.value = o.value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      o.value = o.value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      o.value = o.value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      //o.value = o.value.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入两个小数
      //o.value = o.value.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入两个小数
      o.value = o.value.replace(/^()*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入两个小数
      if (o.value.indexOf(".") < 0 && o.value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        if (o.value.substr(0, 1) == '0' && o.value.length == 2) {
          undefined
          o.value = o.value.substr(1, o.value.length);
        }
      }

      this.dzydsl = o.value;
    },
    validatorDzydbh(val) {
      if (!val) {
        Toast.fail('请填写电子运单编号');
        return false;
      }
      return val;
    },
    validatorDzydpz(val) {
      if (!val) {
        Toast.fail('请填写电子运单品种');
        return false;
      }
      return val;
    },
    validatorDzydsl(val) {
      if (!val) {
        Toast.fail('请填写电子运单数量');
        return false;
      }
      return val;
    },
    validatorDzydtyr(val) {
      if (!val) {
        Toast.fail('请填写电子运单托运人');
        return false;
      }
      return val;
    },
    submitJsy() {
      var that = this;
      //var openid = that.$store.state.wx_info.openid;
      var dzydbh = that.dzydbh ? that.dzydbh : "";
      var dzydpz = that.dzydpz ? that.dzydpz : "";
      var dzydsl = that.dzydsl ? that.dzydsl : 0;
      var dzydtyr = that.dzydtyr ? that.dzydtyr : "";
      var yyid = this.$data.id;

      var xingshizhengzbzmurl = that.xsz_zb_zm_url ? that.xsz_zb_zm_url : "";


      var indzydurl = "";
      var indzydurlArr = that.indzydurlArr;
      if (indzydurlArr.length > 0) {
        for (var k = 0; k < indzydurlArr.length; k++) {
          indzydurl += indzydurlArr[k] + ",";
        }
        //去掉最后一个逗号(如果不需要去掉，就不用写)
        if (indzydurl.length > 0) {
          indzydurl = indzydurl.substr(0, indzydurl.length - 1);
        }
      } else {
        Toast.fail('请上传电子运单');
        return false;
      }

      if(xingshizhengzbzmurl.length <= 0)
      {
        Toast.fail("请先上传车头照片");
        return false;
      }

      that.$data.loadingBtn = true;
      // var formData = JSON.stringify({
      //   yyid: yyid,
      //   indzydbh: dzydbh,
      //   indzydpz: dzydpz,
      //   indzydurl: indzydurl,
      //   indzydsl: dzydsl,
      //   indzydtyr: dzydtyr,
      // });
      var formData = new FormData();
      formData.append('yyid', yyid);
      formData.append('indzydbh', dzydbh);//电子运单编号
      formData.append('indzydpz', dzydpz);//电子运单品种
      formData.append('indzydurl', indzydurl);
      formData.append('indzydsl', dzydsl);
      formData.append('indzydtyr', dzydtyr);

      api.submitdzyd(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          that.updateyyctimg(that.orderDetail,xingshizhengzbzmurl);
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {

          });
        }
      }).catch(function() {
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },
    onOversize() {
      Toast('文件大小不能超过 10Mb');
    },
    afterReadFile(file) {
      var that = this;
      var formData = new FormData();
      var id = that.$data.id;
      const weburl = that.GLOBAL.weburl;
      formData.append('yyid', id);
      formData.append('dzydpics', file.file);
      api.postupdzyd(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data.dzydurl;
          var indzydimageArr = that.indzydimageArr;
          var indzydurlArr = that.indzydurlArr;
          var imageDataArr = imageData.split(',');
          for (var i = 0; i < imageDataArr.length; i++) {
            if (indzydimageArr.length > 0) {
              indzydimageArr.push({
                'url': weburl + '/' + imageDataArr[i]
              });
              indzydurlArr.push(imageDataArr[i]);
            } else {
              indzydimageArr = imageDataArr[i] ? [{
                url: weburl + '/' + imageDataArr[i]
              }] : [];
              indzydurlArr = imageDataArr[i] ? [imageDataArr[i]] : [];
            }
          }

          that.indzydimage = that.indzydimageArr = indzydimageArr;
          that.indzydurlArr = indzydurlArr;

        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });

    },
    deleteUploadImg(file) {
      var that = this;
      const weburl = that.GLOBAL.weburl;
      var indzydimageArr = that.indzydimageArr;
      var indzydimageArrNew = [];
      var indzydurlArrNew = [];
      for (var i = 0; i < indzydimageArr.length; i++) {
        if (indzydimageArr[i].url != file.url) {
          indzydimageArrNew.push(indzydimageArr[i]);
          var path = indzydimageArr[i].url.replace(weburl, '');
          indzydurlArrNew.push(path);
        }
      }
      that.indzydimage = that.indzydimageArr = indzydimageArrNew;
      that.indzydurlArr = indzydurlArrNew;
    },
    uploadButton() {
      var that = this;
      var formData = that.formData;

      if (formData == undefined) {
        Dialog({
          message: '请上传图片'
        });
      } else {
        that.$data.uploadDisabled = true;
        that.$data.uploadLoading = true;

        api.postupdzyd(formData).then(function(resData) {
          var res = JSON.parse(resData);

          that.$data.uploadDisabled = false;
          that.$data.uploadLoading = false;

          if (res.respCode == "0") {
            var yyid = that.$data.id;
            Dialog.alert({
              message: '上传成功',
            }).then(() => {
              that.$router.push({
                name: 'orderdetail',
                params: {
                  id: yyid
                }
              });
            });
          }

        }).catch(function() {
          that.$data.loadingBtn = false;
          Toast.fail('连接失败，请刷新页面');
        });
      }

    },
    //上传电子运单后，更新车头信息
    updateyyctimg(orderDetail)
    {
      var that = this;
      var xingshizhengzbzmurl = that.xsz_zb_zm_url ? that.xsz_zb_zm_url : "";

      var postData = {
        chetouhao:orderDetail.chetouhao,
        xingshizhengzbzmurl:xingshizhengzbzmurl,
        yybh:orderDetail.yybh,
      }

      api.updateyyctimg(postData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          Dialog.alert({
            message: '信息保存成功',
          }).then(() => {
            that.$router.push({
              name: 'orderdetail',
              params: {
                id: that.id
              }
            });
          });
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {

          });
        }
      }).catch(function() {
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },

    //上传行驶证正本正面
    uploadXszZbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_zb_zm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_zb_zm_url = imageData.xingshizhengzbzmurl ? imageData.xingshizhengzbzmurl : "";
          that.$data.xsz_zb_zm_image = imageData.xingshizhengzbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.content-tip{
    margin-top: 7rem; 
}

.content-no-tip{
    margin-top: 4.75rem; 
}

.upload-box {
  background: #fff;
  .upload-dzyd-box {
    margin-left: 1rem;
  }
  .upload-titile {
    padding: 0.675rem 1rem;
  }
}

.unit {
    padding-left: 0.2rem;
    color: #969799;
}

.title-extend {
    line-height: 1.5;
}

.notice-tip-box{
  position: fixed;
  top: 3.75rem;
  width: 100%;
  z-index: 99;
}
</style>
